import React__default from 'react';
import { cssClassPrefix } from '../../constants/generalConstants.js';

/**
 * Copyright 2020, IntraLinks, Inc. All rights reserved.
 */
var highlightText = function highlightText(text, highlight) {
  if (highlight) {
    var parts = text.split(new RegExp("(".concat(highlight, ")"), 'gi'));
    return /*#__PURE__*/React__default.createElement("span", null, parts.map(function (part, i) {
      return part.toLowerCase() === highlight.toLowerCase() ?
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default.createElement("span", {
        className: "".concat(cssClassPrefix, "--highlighted-text"),
        key: i
      }, part) : part;
    }));
  }
  return text;
};

export { highlightText };
